"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _itemView = _interopRequireDefault(require("./itemView.js"));

var _commonItemContainer = require("./commonItemContainer.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var ItemContainer =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ItemContainer, _React$Component);

  function ItemContainer(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.displayName = 'ItemContainer';
    return _this;
  }

  var _proto = ItemContainer.prototype;

  _proto.isSmallItem = function isSmallItem() {
    var maxWidth = 90;
    var maxHeight = 90;

    if (this.props.styleParams.cubeImages && this.props.styleParams.cubeType === 'fit') {
      if (this.props.style.orientation === 'landscape') {
        //wide image
        return this.props.style.width / this.props.style.ratio <= maxHeight;
      } else {
        //tall image
        return this.props.style.height * this.props.style.ratio <= maxWidth;
      }
    } else {
      return this.props.style.width <= maxWidth || this.props.style.height <= maxHeight;
    }
  };

  _proto.isNarrow = function isNarrow() {
    return this.props.style.width < 200;
  };

  _proto.isShort = function isShort() {
    return this.props.style.height < 150;
  };

  _proto.render = function render() {
    this.props.love.showCounter = this.props.styleParams.loveCounter && !this.isSmallItem() && !this.isNarrow();
    return _react["default"].createElement(_itemView["default"], _extends({
      layout: "galleryItem",
      className: "image",
      isSmallItem: this.isSmallItem(),
      isNarrow: this.isNarrow(),
      isShort: this.isShort()
    }, this.props));
  };

  return ItemContainer;
}(_react["default"].Component);

var _default = (0, _commonItemContainer.CommonItemContainer)(ItemContainer);

exports["default"] = _default;